import * as ActionTypes from '../actions/ImageEditorFirmsActionTypes';
import InitialState from './ImageEditorFirmsInitialState';
import { IImageEditorFirm } from '../Entities';

export default function imageEditorFirmsReducer(
    state: any = InitialState.imageEditorFirms,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.GET_IMAGE_EDITOR_FIRMS_SUCCESS:
            return {
                ...state,
                list: action.result
            };

        case ActionTypes.SAVE_IMAGE_EDITOR_FIRM_SUCCESS:
            return {
                ...state,
                list: [...state.list, action.result]
            };

        case ActionTypes.GET_IMAGE_EDITOR_FIRM_SUCCESS:
            return {
                ...state,
                list: [...state.list],
                modal: {
                    ...state.modal,
                    imageEditorFirm: action.result
                }
            };

        case ActionTypes.UPDATE_IMAGE_EDITOR_FIRM_FORM_SUCCESS:
            let newValue = state.list.find((imageEditorFirm: IImageEditorFirm) => {
                return imageEditorFirm.id === action.result.id;
            });
            newValue = {
                ...newValue,
                downloadStorageKey: action.result.downloadStorageKey,
                name: action.result.name,
                brokerFirmDefault: action.result.brokerFirmDefault,
                brokerFirmDefaultExpress: action.result.brokerFirmDefaultExpress
            };
            return {
                ...state,
                list: [
                    ...state.list.filter((imageEditorFirm: IImageEditorFirm) => {
                        return imageEditorFirm.id !== action.result.id;
                    }),
                    newValue
                ]
            };

        case ActionTypes.CHANGE_ISDISCONTINUED_IMAGE_EDITOR_FIRM_SUCCESS:
            return {
                ...state,
                list: [
                    ...state.list.map((imageEditorFirm: IImageEditorFirm) => {
                        if (imageEditorFirm.id === action.result) {
                            return {
                                ...imageEditorFirm,
                                isDiscontinued: !imageEditorFirm.isDiscontinued
                            };
                        }
                        return imageEditorFirm;
                    })
                ]
            };
        default:
            return state;
    }
}
